import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/basic-info/warehouse-list`;

export const warehouseListRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:warehouseId`,
  shelvesList: `${baseRoute}/:warehouseId/shelves-list`,
  addNewShelf: `${baseRoute}/:warehouseId/shelves-list/create`,
  editShelf: `${baseRoute}/:warehouseId/shelves-list/edit/:shelfId`,
} as const;

export type IWarehouseListRouteParams = IExtractRouteParamMap<
  typeof warehouseListRoutesObj
>;

export const warehouseListPath = createPaths<
  typeof warehouseListRoutesObj,
  IWarehouseListRouteParams
>(warehouseListRoutesObj);
